<template>
  <footer class="container-fluid custom-footer fixed-bottom">
    <div class="row">
      <div class="col">
        <span class="text-green">DYG Digital</span> © Chile 2023. Todos los
        derechos reservados
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<style scoped lang="scss">
.custom-footer {
  text-align: center;
  padding: 1rem;
  background: #ffffff;
  border-top: 1px solid #5b7823;
  font-family: 'Manrope', sans-serif;
  color: #000;
  font-weight: 400;
  .text-green {
    color: #5b7823;
    font-weight: 700;
  }
}
</style>
